import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import Input from '../common/form/Input'
import Modal from '../common/Modal'
import CancelButton from '../common/buttons/CancelButton'
import SubmitButton from '../common/buttons/SubmitButton'

import classes from './OrganizationFormModal.module.scss'

const OrganizationFormModal = ({ isOpen, organization, onClose, onSubmit }) => {
  const { t } = useTranslation()
  const [name, setName] = useState(organization?.name || '')
  const [error, setError] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()
    if (name.trim() === '') {
      setError(t('organizations.form.errors.name'))
      return
    }

    setIsSubmitting(true)
    onSubmit(name.trim())
      .catch((errors) => setError(errors.name?.[0] || t('organizations.form.errors.generic')))
      .finally(() => setIsSubmitting(false))
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} className={classes.modalContent}>
      <div className={classes.organizationFormModal}>
        <h2 className={classes.modalTitle}>
          {organization ? t('organizations.form.editTitle', { name: organization.name }) : t('organizations.form.createTitle')}
        </h2>

        <form onSubmit={handleSubmit} className={classes.modalForm}>
          <div className='mb-4'>
            <label htmlFor='organizationName'>
              {t('common.field.name')} <span className='required-text'>*</span>
            </label>
            <Input
              id='organizationName'
              type='text'
              value={name}
              placeholder={t('organizations.form.namePlaceholder')}
              onChange={(e) => { setName(e.target.value); setError(null) }}
              error={error}
            />
          </div>

          <div className='row pt-2'>
            <div className='col-6'>
              <CancelButton onClick={onClose} buttonMessage={t('common.cancel')} />
            </div>
            <div className='col-6'>
              <SubmitButton type='submit' buttonMessage={t('common.save')} loading={isSubmitting} noTopMargin />
            </div>
          </div>
        </form>
      </div>
    </Modal>
  )
}

OrganizationFormModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  organization: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }),
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default OrganizationFormModal
